module.exports = __webpack_public_path__ + "img/4.2fa8224e.jpg";